/*
 * MDB shim for InputFile
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Activities/activities-add.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 */

export default function InputFile({ getValue, onChange, ...rest }) {
    return (
        <input
            type="file"
            {...rest}
            onChange={(e) => {
                getValue?.(e.target.files);
                onChange?.(e);
            }}
        />
    );
}